import {
  GET_GENERAL_SUCCESS,
  GET_GENERAL_FAIL,
  SEARCH_GENERAL_SUCCESS,
  SEARCH_GENERAL_FAIL,
  GET_COUNTRY_SUCCESS,
  GET_COUNTRY_FAIL,
  GET_STATE_SUCCESS,
  GET_STATE_FAIL,
  GET_CITY_SUCCESS,
  GET_CITY_FAIL,
  RESET_GENERAL_STATE,
  RESET_ATTACHMENT_STATE,
  GET_ATTACHMENT_SUCCESS,
  GET_ATTACHMENT_FAIL,
  RESET_PROFILE_ATTACHMENT_STATE,
  GET_PROFILE_ATTACHMENT_SUCCESS,
  GET_PROFILE_ATTACHMENT_FAIL,
  RESET_THUMBNAIL_ATTACHMENT_STATE,
  GET_THUMBNAIL_ATTACHMENT_SUCCESS,
  GET_THUMBNAIL_ATTACHMENT_FAIL,
  GET_VOUCHER_LIST_SUCCESS,
  GET_VOUCHER_LIST_FAIL,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAIL,
  RESET_EMAIL_STATE,
  SET_CURRENT_USER,
  GET_REGION_SUCCESS,
  GET_REGION_FAIL,
  GET_ADVERT_INTEREST_RATE_SUCCESS,
  GET_ADVERT_INTEREST_RATE_FAIL,
  ACCEPT_INVITATION_SUCCESS,
  ACCEPT_INVITATION_FAIL,
  RESET_REGION_STATE,
} from "./actionTypes"

const INIT_STATE = {
  bike_advert_plans: [],
  erps: [],
  bike_make: [],
  bike_makes: [],
  dealer_salesmans: [],
  taggings: [],
  bike_model: [],
  brand: [],
  category: [],
  sub_category: [],
  states: [],
  country: [],
  city: [],
  region: [],
  send_email_response: [],
  current_user: [],
  advertInterestRate: [],
  acceptInvitationRes: [],
  loan_interest_rates: [],
}

const General = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GENERAL_SUCCESS:
      return {
        ...state,
        bike_advert_plans: action.payload?.library?.bike_advert_plans,
        erps: action.payload?.library?.erps,
        bike_make: action.payload?.library?.bike_make,
        bike_makes: action.payload?.library?.bike_makes,
        dealer_salesmans: action.payload?.library?.dealer_salesmans,
        dealer_branches: action.payload?.library?.dealer_branches,
        taggings: action.payload?.library?.taggings,
        bike_model: action.payload?.library?.bike_model,
        bike_models: action.payload?.library?.bike_models,
        bike_types: action.payload?.library?.bike_types,
        license_categories: action.payload?.library?.license_categories,
        brand: action.payload?.library?.brand,
        category: action.payload?.library?.categories,
        sub_category: action.payload?.library?.sub_category,
        states: action.payload?.library?.states,
        loan_interest_rates: action.payload?.library?.loan_interest_rates,
        countries: action.payload?.library?.countries,
        transmissions: action.payload?.library?.transmissions,
        generalCommonCode: action.payload
      }

    case GET_GENERAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case SEARCH_GENERAL_SUCCESS:
      return {
        ...state,
        bike_make_search: action.payload?.library,
      }

    case SEARCH_GENERAL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case SET_CURRENT_USER:
      return {
        ...state,
        current_user: action.payload,
      }

    case GET_COUNTRY_SUCCESS:
      return {
        ...state,
        country: action.payload,
      }

    case GET_COUNTRY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_STATE_SUCCESS:
      return {
        ...state,
        state: action.payload,
      }

    case GET_STATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CITY_SUCCESS:
      return {
        ...state,
        city: action.payload,
      }

    case GET_CITY_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_REGION_SUCCESS:
      return {
        ...state,
        region: action.payload?.data,
        regionRegister: action.payload,
      }

    case GET_REGION_FAIL:
      return {
        ...state,
        error: action.payload,
        region: action.payload?.data,
        regionRegister: action.payload,
      }

    case GET_ATTACHMENT_SUCCESS:
      return {
        ...state,
        attachment: action.payload,
      }
    case GET_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_PROFILE_ATTACHMENT_SUCCESS:
      return {
        ...state,
        profileAttachment: action.payload,
      }
    case GET_PROFILE_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_THUMBNAIL_ATTACHMENT_SUCCESS:
      return {
        ...state,
        thumbnailAttachment: action.payload,
      }
    case GET_THUMBNAIL_ATTACHMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_VOUCHER_LIST_SUCCESS:
      return {
        ...state,
        voucherList: action.payload,
      }
    case GET_VOUCHER_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case SEND_EMAIL_SUCCESS:
      return {
        ...state,
        send_email_response: action.payload,
      }
    case SEND_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ADVERT_INTEREST_RATE_SUCCESS:
      return {
        ...state,
        advertInterestRate: action.payload
      }
    case GET_ADVERT_INTEREST_RATE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ACCEPT_INVITATION_SUCCESS:
      return {
        ...state,
        acceptInvitationRes: action.payload
      }
    case ACCEPT_INVITATION_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case RESET_GENERAL_STATE:
      return {
        ...state,
      }

    case RESET_ATTACHMENT_STATE:
      return {
        ...state,
        attachment: [],
      }

    case RESET_THUMBNAIL_ATTACHMENT_STATE:
      return {
        ...state,
        thumbnailAttachment: [],
      }

    case RESET_PROFILE_ATTACHMENT_STATE:
      return {
        ...state,
        profileAttachment: []
      }
    case RESET_REGION_STATE:
      return {
        ...state,
        regionRegister: []
      }

    case RESET_EMAIL_STATE:
      return {
        ...state,
        send_email_response: []
      }
    default:
      return state
  }
}

export default General
